import { render, staticRenderFns } from "./PriorityPurchase.vue?vue&type=template&id=56466f47&"
import script from "./PriorityPurchase.vue?vue&type=script&lang=ts&"
export * from "./PriorityPurchase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports